/* Open Road — product image gallery.
 *
 * Progressive enhancement only. Without JS the main image still renders and
 * the thumbnails are still visible as an image strip; clicking simply does
 * nothing. Nothing here is required for the page to be usable.
 *
 * Markup contract:
 *   [data-or-gallery]              wrapper
 *     [data-or-gallery-main]       the large <img> whose src gets swapped
 *     [data-or-gallery-full]       a thumbnail <img>; the attribute holds the
 *                                  large-size URL to swap in
 */
(function () {
  function initGallery(root) {
    var main = root.querySelector('[data-or-gallery-main]');
    var thumbs = root.querySelectorAll('[data-or-gallery-full]');
    if (!main || !thumbs.length) return;

    root.addEventListener('click', function (event) {
      var thumb = event.target.closest('[data-or-gallery-full]');
      if (!thumb || !root.contains(thumb)) return;

      var full = thumb.getAttribute('data-or-gallery-full');
      if (full) {
        main.setAttribute('src', full);
        /* The main image may carry a srcset from image_tag; a stale srcset
           would win over the new src and silently show the old photo. */
        main.removeAttribute('srcset');
        var alt = thumb.getAttribute('alt');
        if (alt) main.setAttribute('alt', alt);
      }

      for (var i = 0; i < thumbs.length; i++) {
        thumbs[i].classList.toggle('is-on', thumbs[i] === thumb);
      }
    });
  }

  function init() {
    var galleries = document.querySelectorAll('[data-or-gallery]');
    for (var i = 0; i < galleries.length; i++) initGallery(galleries[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
